(function() {
    'use strict';

    angular
        .module('app.aeronaves')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/aeronaves',
                config: {
                    templateUrl: 'app/aeronaves/list.html',
                    controller: 'aeronaves.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-aeronave/:id?',
                config: {
                    templateUrl: 'app/aeronaves/edit.html',
                    controller: 'aeronaves.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
